import Keycloak from 'keycloak-js';

export function isAuthorized(
  authenticated: boolean,
  keycloak?: Keycloak,
  roles?: string[],
): boolean {
  if (!keycloak || !authenticated) return false;
  if (!roles) return true;

  return roles.some((r) => {
    const [role, clientId] = r.split(':', 2).reverse();

    const realm = keycloak.hasRealmRole(role);
    const resource = keycloak.hasResourceRole(role, clientId);

    return realm || resource;
  });
}
